import useShowTooltip from 'hooks/useShowTooltip';
import { useEffect } from 'react';
import { useRef } from 'react';
import { Pie } from 'react-chartjs-2';

var colors = [
  '#a5b592',
  '#f3a447',
  '#e7bc29',
  '#d092a7',
  '#9c85c0',
  '#809ec2',
  '#64754f',
  '#ff6600',
  '#937510',
  '#94405d'
];

const RankingChartItem = ({ index, data }) => {
  let number = 0;
  let prevTotal = null;

  const chartData = data.map((elm, index) => {
    if (prevTotal !== elm.count) {
      number++;
    }

    prevTotal = elm.count;

    return {
      ...elm,
      number
    };
  });

  useShowTooltip();

  const legendId = `legend-${index}`;

  const chart = {
    data: {
      labels: chartData.map((elm) => elm.label),
      datasets: [
        {
          data: chartData.map((elm) => elm.count),
          backgroundColor: colors,
          label: 'Dataset'
        }
      ]
    },
    options: {
      responsive: true,
      legend: {
        display: false
      },
      legendCallback: function (chart) {
        var text = [];
        text.push('<ul class="pie-chart-custom-legend">');
        var ds = chart.data.datasets[0];
        var sum = ds.data.reduce(function add(a, b) {
          return a + b;
        }, 0);
        for (var i = 0; i < ds.data.length; i++) {
          text.push('<li>');
          var perc = Math.round((100 * ds.data[i]) / sum, 0);
          text.push(
            `<span class="pie-chart-custom-legend__color" style="background-color: ${ds.backgroundColor[i]}"></span>
             <span class="pie-chart-custom-legend__title">
               <span>${chartData[i].number}. ${chart.data.labels[i]} (${perc}%)</span>
             </span>`
          );
          text.push('</li>');
        }
        text.push('</ul>');
        return text.join('');
      },
      animation: {
        animateScale: true,
        animateRotate: true
      },
      tooltips: {
        callbacks: {
          label: function (item, data) {
            var sum = data.datasets[0]['data'].reduce(function add(a, b) {
              return a + b;
            }, 0);

            var perc = Math.round((100 * data.datasets[0]['data'][item.index]) / sum, 0);

            return `${chartData[item.index].number}. ${data.labels[item.index]}: ${perc}%`;
          }
        }
      }
    }
  };

  const chartRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (chartRef.current) {
        document.getElementById(legendId).innerHTML =
          chartRef.current?.chartInstance.generateLegend();
      }
    }, 500);
  }, [chartRef, legendId]);

  if (chart.data.datasets[0].data.reduce((total, count) => total + count, 0) <= 0) {
    return <p className="mb-0 text-center">There is no data!</p>;
  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <div id={legendId}></div>
      </div>
      <Pie ref={chartRef} data={chart.data} options={chart.options} className="chart-canvas" />
    </>
  );
};

export default RankingChartItem;
